/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Accordion from 'shared/ui/components/Accordion.vue';
import Waitlist from 'ui/components/session-registration/settings/Waitlist.vue';

const __vue_script__ = {
    name: 'SessionRegSettings',

    components: {
        Accordion,
        Waitlist
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            ready: false,
            loading: false,
            registry: {},
            settings: {},
            submitting: false,
            innerValue: {
                waitlist: {}
            }
        };
    },

    computed: {
        disabled() {
            return this.loading || this.submitting;
        }
    },

    created() {
        this.loadSettings();
    },

    methods: {
        /**
         * Loads the settings for the session registration.
         *
         * @param {boolean} [fresh=false] - Indicates whether to fetch fresh settings or use cached settings.
         */
        async loadSettings(fresh = false) {
            try {
                console.info('[SessionRegSettings] Loading settings');
                this.loading = true;
                this.settings = await this.$services.settings.getSetting(this.params.event._id, 'waitlist', fresh ? 0 : 5000);
                this.registry = await this.$services.settings.getRegistry(this.params.event._id);

                this.innerValue.waitlist = this.settings || {};
            } catch (error) {
                console.error('[SessionRegSettings] Error loading settings', error);
            } finally {
                this.loading = false;
                this.ready = true;
            }
        },

        /**
         * Saves the session registration settings.
         */
        async save() {
            try {
                console.info('[SessionRegSettings] Saving settings', this.innerValue);
                this.submitting = true;

                await this.$services.settings.saveSetting(this.params.event._id, 'waitlist', this.innerValue.waitlist);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('general_settings.messages.settings_save_success').toString(),
                    type: 'success',
                    duration: 5000
                });

            } catch (error) {
                console.error('[SessionRegSettings] Error saving settings', error);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('general_settings.messages.settings_save_failure').toString(),
                    type: 'success',
                    duration: 5000
                });

            } finally {
                this.loadSettings(true);
                this.submitting = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"session-reg-settings",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.save)}}},[(_vm.ready)?_c('accordion',{attrs:{"headers-i18n-prefix":"registration.sessions_configuration","default-open-item":"waitlist","animated":true,"slim":true},scopedSlots:_vm._u([{key:"waitlist",fn:function(ref){return [_c('waitlist',{attrs:{"disabled":_vm.disabled,"event":_vm.params.event,"registry":_vm.registry},model:{value:(_vm.innerValue.waitlist),callback:function ($$v) {_vm.$set(_vm.innerValue, "waitlist", $$v)},expression:"innerValue.waitlist"}})]}}],null,true)}):_vm._e(),_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.$t('general.save')))])])],1)]}}])})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SessionRegSettings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__